module.exports = __webpack_public_path__ + "static/img_2405-d110cad15a9caf721af22bb4a6a677fd.webp";